import React from 'react';

import { EHeadingSize } from '@domain/enums/components/EHeading';

import { Linepay as LinepayIcon } from '@profitfy/pakkun-icons';

import { useOtherGatewayIntegration } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';
import { useTheme } from 'styled-components';

import IntegrateForm from '@components/Dashboard/IntegrationCenter/Sidemodal/Gateway/OtherGateway/IntegrateForm';

import SkeletonLoading from './SkeletonLoading';

import * as S from './styles';

const Linepay: React.FC = () => {
  const theme = useTheme();

  const { isLoadingOtherGateways, otherGateways } = useOtherGatewayIntegration();

  if (isLoadingOtherGateways || Boolean(!otherGateways)) {
    return <SkeletonLoading />;
  }

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <LinepayIcon size={52} color={theme.colors.green.default} />
        <S.Heading type={EHeadingSize.H4}>Integração com Linepay</S.Heading>
      </S.HeadingWrapper>

      <IntegrateForm gatewayName="Linepay" gatewayId="linepay" />
    </S.Wrapper>
  );
};

export default Linepay;
